export default "__VITE_ASSET__bgZGcyme__"